import { createRouter, RouteRecordRaw, createWebHashHistory } from 'vue-router'

import login from './views/login'
import person from './views/person'
import recruit from './views/recruit'
import notice from './views/notice'
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    redirect: '/recruit/home'
  },
  ...login,
  ...person,
  ...recruit,
  ...notice
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  next()
  document.title = to.meta.title as string;
})

export default router
